<template>
  <Main>
    <HeaderModality @modal="showModalCreate" @filter="updateFilter" />
    <ModalityTable :filter="filter" />
    <ModalModality
      @close="closeModal"
      v-model="modal"
      v-if="modal"
      @submit="submit"
      title="ADICIONAR MODALIDADE"
      :form="form"
    />
  </Main>
</template>
<script>
import HeaderModality from "../components/HeaderModality";
import ModalityTable from "../components/ModalityTable";
import ModalModality from "../components/ModalModality";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    form: {
      nome: null,
      ativo: true,
      area: null
    },
    modal: false,
    filter: null
  }),
  components: {
    HeaderModality,
    ModalityTable,
    ModalModality
  },
  mixins: [LoadingRequest],
  created() {
    this.fetchModality();
    this.form.area = this.myInfo.area_usuario;
  },
  computed: {
    ...mapState("me", ["myInfo"])
  },
  methods: {
    ...mapActions("modality", [
      "requestModality",
      "requestPostModality",
      "requestUploadIcon"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    fetchModality() {
      this.withLoading(this.requestModality());
    },
    showModalCreate() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    async submit() {
      this.modal = false;
      if (this.form.imagem != null && !this.form.imagem.url) {
        this.form.imagem = await this.withLoading(
          this.requestUploadIcon(this.getUploadFilePayload(this.form.imagem))
        );
      }
      this.withLoading(
        this.requestPostModality(this.form).then(() => {
          this.showAlertNotification({
            message: "Modalidade criada com sucesso.",
            type: "success"
          });
        })
      );
      // resetar formulário
      this.form = {
        nome: null,
        ativo: true
      };
    },
    updateFilter(value) {
      this.filter = value;
    }
  }
};
</script>
